import { defineRouting } from 'next-intl/routing'
import { intlPathnames } from '@/seo/routes'

export const routing = defineRouting({
  locales: ['en', 'sv'],
  defaultLocale: 'sv',
  localePrefix: 'always',
  localeDetection: false,
  alternateLinks: false,
  pathnames: intlPathnames,
})
